import { render, staticRenderFns } from "./carruades-de-lafite.vue?vue&type=template&id=bb4544ee&scoped=true"
import script from "./carruades-de-lafite.vue?vue&type=script&lang=js"
export * from "./carruades-de-lafite.vue?vue&type=script&lang=js"
import style0 from "./carruades-de-lafite.vue?vue&type=style&index=0&id=bb4544ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4544ee",
  null
  
)

export default component.exports